import { createUseStyles } from 'react-jss'
import { BLUE, BLUE_25 } from '@omnilert/components'


const useStyles = createUseStyles({
  cameraButton: {
    height: ['100%', '!important'],
    marginBottom: '5px',
    padding: '0 !important'
  },
  cameraIcon: ({ uploadDisabled }) => ({
    '--icon__primary__stroke__color': uploadDisabled ? BLUE_25 : BLUE
  }),
  errorMessage: {
    display: 'flex',
    backgroundColor: ['var(--text_area_background)', '!important'],
    padding: '0px 16px 10px 16px'
  },
  submitButton: {
    height: ['100%', '!important'],
    marginRight: '10px',
    padding: '17px !important'
  },
  textArea: {
    backgroundColor: ['var(--text_area_background)', '!important'],
    borderRadius: '5px 5px 0px 0px !important',
    border: 'none !important',
    color: 'var(--text__primary) !important',
    height: ['100px', '!important']
  },
  textAreaButtonContainer: {
    display: 'flex',
    backgroundColor: ['var(--text_area_background)', '!important'],
    borderRadius: ['0px 0px 5px 5px', '!important'],
    justifyContent: 'space-between',
    padding: '15px 5px'
  },
  tipInputContainer: {
    background: 'var(--primary__page__background)',
    border: '2px solid var(--input__border)',
    borderRadius: '5px',
    margin: '5px auto',
    width: '90%'
  },
  uploadContainer: ({ uploadDisabled }) => ({
    alignItems: 'center',
    borderRadius: '3px',
    border: `2px dashed ${uploadDisabled ? BLUE_25 : BLUE}`,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px',
    padding: '4px 16px',
    '&:hover': {
      cursor: 'pointer'
    }
  })

})

export default useStyles
